import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, Fonts, Spacing } from "@snapchat/snap-design-system";

export const Cell = styled.div`
    color: ${Colors.Black.V100};
`;

export const HeadingText = styled.span`
    ${Fonts.Heading.H700};
    color: ${Colors.Black.V100};
`;

export const BoldText = styled.span`
    ${Fonts.Heading.H600};
    color: ${Colors.Black.V100};
`;

export const ParagraphText = styled.span`
    ${Fonts.Paragraph.P300};
    color: ${Colors.Black.V100};
`;

export const ParagraphTextBold = styled(ParagraphText)`
    ${Fonts.Paragraph.P300};
`;

export const RemainingDaysStatus = styled.span<{ status?: "warning" | "default" }>`
    display: inline-block;

    width: ${Spacing.XS}px;
    height: ${Spacing.XS}px;
    margin-right: ${Spacing["2XS"]}px;

    background-color: ${({ status = "default" }) => (status === "warning" ? Colors.Orange.V100 : Colors.Green.V100)};
    border-radius: 50%;
`;

export const moneyCss = css`
    width: 20px;
    vertical-align: middle;
`;
